import React from 'react';
import useReconnectIdentity from '../utils/useReconnectIdentity';

export default function SalesforceReconnectAlert({ onReconnected }) {
  const { reconnect, reconnecting } = useReconnectIdentity();

  const handleReconnect = async () => {
    const ok = await reconnect('salesforce');
    if (ok) {
      onReconnected?.();
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        padding: '10px 12px',
        margin: '8px 0',
        background: '#fff3cd',
        border: '1px solid #ffe69c',
        borderRadius: '4px',
        color: '#664d03',
        fontSize: '13px',
      }}
    >
      <span>
        ⚠️ Your Salesforce account has been disconnected. Please reconnect it in Settings → Integrations.
      </span>
      <button
        type="button"
        onClick={handleReconnect}
        disabled={reconnecting}
        style={{
          flexShrink: 0,
          padding: '6px 14px',
          background: '#1976d2',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: reconnecting ? 'default' : 'pointer',
          fontWeight: 600,
        }}
      >
        {reconnecting ? 'Reconnecting…' : 'Reconnect'}
      </button>
    </div>
  );
}
